import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-authen',
  templateUrl: '../_views/authen.component.html',
  styleUrls: ['../_views/authen.component.scss']
})
export class AuthenComponent implements OnInit {
  constructor() {
  }
  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/authen/_controller/authen.component.ts